import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

// Base props common to all variants
type Props = {
  error?: string | null;
  duration?: number;
  onClose: () => void;
};

const ErrorToast = ({ error, duration = 5000, onClose }: Props) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (!error) return;

    const startTime = Date.now();
    const timer = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, 100 - (elapsed / duration) * 100);
      setProgress(remaining);

      if (remaining === 0) {
        onClose();
        clearInterval(timer);
      }
    }, 10);

    return () => clearInterval(timer);
  }, [error, duration, onClose]);

  if (!error) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md overflow-hidden rounded-lg bg-popover border-destructive shadow-lg">
      <div className="flex items-center justify-between p-4 text-sm font-medium text-foreground">
        <span>{error}</span>
        <button onClick={onClose} className="ml-2 text-muted-foreground hover:text-foreground">
          <X size={16} />
        </button>
        <div className="absolute bottom-0 left-0 h-1 w-full bg-background">
          <div
            className="h-full bg-primary transition-all duration-100 ease-linear"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorToast;
